/**
 * Nguồn dữ liệu dự toán tùy chỉnh báo cáo

 */
export default {
  Audit: 1, // kiểm tra
  Estimate: 2, // lập dự toán
  Summary: 3, // tổng hợp dự toán
  Submit: 4, // lần nộp
};
